// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fJ4iy","descriptionList":"styles_descriptionList__GYZJu","content":"styles_content__LL8bE","column":"styles_column__FbIPJ"};